module.exports = __webpack_public_path__ + "static/media/turing-magic.c2b9ac8e.svg";